(() => {
const bound = new WeakSet();
function initializeHeader(root = document) {
  const menu = root.querySelector('#pmb-menu');
  const toggle = root.querySelector('.pmb-menu-toggle');
  if (!menu || !toggle || bound.has(menu)) return;
  bound.add(menu);
  let closing = false, previousOverflow = '', start = null, suppressClickUntil = 0;
  function close() {
    if (!menu.open || closing) return;
    closing = true;
    start = null;
    menu.classList.remove('is-dragging');
    menu.style.removeProperty('transform');
    menu.classList.remove('is-open');
    setTimeout(() => {
      menu.close();
      document.documentElement.style.overflow = previousOverflow;
      toggle.setAttribute('aria-expanded', 'false');
      closing = false;
      toggle.focus({preventScroll:true});
    }, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 300);
  }
  toggle.addEventListener('click', () => {
    if (menu.open) return close();
    previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    menu.showModal();
    toggle.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(() => requestAnimationFrame(() => menu.classList.add('is-open')));
  });
  menu.querySelector('.pmb-menu-close').addEventListener('click', close);
  menu.addEventListener('cancel', event => { event.preventDefault(); close(); });
  menu.addEventListener('click', event => {
    if (performance.now() < suppressClickUntil) { event.preventDefault(); event.stopPropagation(); return; }
    if (event.target === menu && event.clientX > menu.getBoundingClientRect().right) close();
    if (event.target.closest('a')) close();
  }, true);
  function resetDrag() {
    start = null;
    menu.classList.remove('is-dragging');
    menu.style.removeProperty('transform');
  }
  menu.addEventListener('touchstart', event => {
    if (closing || !menu.classList.contains('is-open')) return;
    if (event.touches.length !== 1) { resetDrag(); return; }
    const touch = event.touches[0], rect = menu.getBoundingClientRect();
    if (touch.clientX < rect.left || touch.clientX > rect.right) return;
    start = {x:touch.clientX, y:touch.clientY, time:performance.now(), axis:null, dx:0};
  }, {passive:true});
  menu.addEventListener('touchmove', event => {
    if (!start) return;
    if (event.touches.length !== 1) { resetDrag(); return; }
    const touch = event.touches[0];
    const dx = touch.clientX - start.x, dy = touch.clientY - start.y;
    if (!start.axis) {
      if (Math.max(Math.abs(dx), Math.abs(dy)) < 8) return;
      start.axis = Math.abs(dx) > Math.abs(dy) * 1.2 ? 'horizontal' : 'vertical';
    }
    if (start.axis !== 'horizontal') return;
    event.preventDefault();
    start.dx = Math.max(-menu.offsetWidth, Math.min(0, dx));
    menu.classList.add('is-dragging');
    menu.style.transform = `translateX(${start.dx}px)`;
  }, {passive:false});
  menu.addEventListener('touchend', () => {
    if (!start) return;
    if (start.axis === 'horizontal') {
      const distance = -start.dx;
      const speed = distance / Math.max(1, performance.now() - start.time);
      suppressClickUntil = performance.now() + 450;
      // Commit a deliberate pull or quick flick; short drags settle back open.
      if (distance > menu.offsetWidth * .28 || (distance > 35 && speed > .5)) { close(); return; }
    }
    resetDrag();
  }, {passive:true});
  menu.addEventListener('touchcancel', () => {
    if (start?.axis === 'horizontal') suppressClickUntil = performance.now() + 450;
    resetDrag();
  }, {passive:true});
  const desktop = matchMedia('(min-width:901px)');
  const desktopChanged = event => {if(event.matches) close();};
  desktop.addEventListener('change', desktopChanged);
  const unloadHeader = event => { if (!event.target.contains(menu)) return; if (menu.open) { menu.close(); document.documentElement.style.overflow = previousOverflow; } desktop.removeEventListener('change', desktopChanged); document.removeEventListener('shopify:section:unload', unloadHeader); };
  document.addEventListener('shopify:section:unload', unloadHeader);
}

function initializeFooter(root = document) {
  const mobile = matchMedia('(max-width:650px)');
  const toggles = [...root.querySelectorAll('.footer-toggle')].filter(button => !bound.has(button));
  toggles.forEach(button => bound.add(button));
  function sync() {
    toggles.forEach(button => {
      button.disabled = !mobile.matches;
      button.setAttribute('aria-expanded', String(!mobile.matches));
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (panel) panel.hidden = mobile.matches;
    });
  }
  toggles.forEach(button => button.addEventListener('click', () => {
    const expanded = button.getAttribute('aria-expanded') === 'true';
    button.setAttribute('aria-expanded', String(!expanded));
    const panel = document.getElementById(button.getAttribute('aria-controls'));
    if (panel) panel.hidden = expanded;
  }));
  if (!toggles.length) return;
  mobile.addEventListener('change', sync);
  const unloadFooter = event => { if (!toggles.some(button => event.target.contains(button))) return; mobile.removeEventListener('change', sync); document.removeEventListener('shopify:section:unload', unloadFooter); };
  document.addEventListener('shopify:section:unload', unloadFooter);
  sync();
}
initializeHeader();
initializeFooter();
document.addEventListener("shopify:section:load", event => {initializeHeader(event.target);initializeFooter(event.target);});
})();
